import React from 'react';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { STATES } from '../util/states';

type InputProps = {
  value: string | null;
  onChange: (state: string | null) => void;

  // Currently just using this to change the label to have a star
  // We probably should do something more.
  required?: boolean;
};

export const StateAutocomplete = (props: InputProps) => {
  const { value, onChange, required } = props;

  const handleChange = (_e: React.ChangeEvent<{}>, option: string | null) => {
    onChange(option);
  };

  // IF (08/07/20): This is to prevent the native browser autofill from showing over the top of the
  // autocomplete dropdown. Turning if "off" doesn't work because chrome is recognizing there's an
  // address form on the page and trying to autofill regardless. Setting it to something obscure
  // prevents it from showing at all.
  const handleFocus = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    event.target.setAttribute('autocomplete', 'dont-show');
  };

  return (
    <Autocomplete
      autoHighlight
      fullWidth
      openOnFocus
      options={Object.keys(STATES)}
      value={value}
      getOptionLabel={(option) => STATES[option as keyof typeof STATES]}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={`State${required ? ' *' : ''}`}
          onFocus={handleFocus}
          fullWidth
        />
      )}
    />
  );
};
